/**
 * Enums for the commerce library
 */

export enum EOrderStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  FULFILLED = "FULFILLED",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  REFUNDED = "REFUNDED",
}

export enum EProductSortKey {
  TITLE = "TITLE",
  PRICE = "PRICE",
  CREATED_AT = "CREATED_AT",
  UPDATED_AT = "UPDATED_AT",
  BEST_SELLING = "BEST_SELLING",
  MANUAL = "MANUAL",
}

export enum ECollectionSortKey {
  TITLE = "TITLE",
  CREATED_AT = "CREATED_AT",
  UPDATED_AT = "UPDATED_AT",
  MANUAL = "MANUAL",
}

export enum EOrderSortKey {
  CREATED_AT = "CREATED_AT",
  UPDATED_AT = "UPDATED_AT",
  ORDER_NUMBER = "ORDER_NUMBER",
  TOTAL_PRICE = "TOTAL_PRICE",
}

export enum EAvailability {
  IN_STOCK = "IN_STOCK",
  OUT_OF_STOCK = "OUT_OF_STOCK",
  PREORDER = "PREORDER",
}

export enum EPaymentStatus {
  PENDING = "PENDING",
  AUTHORIZED = "AUTHORIZED",
  PAID = "PAID",
  PARTIALLY_PAID = "PARTIALLY_PAID",
  REFUNDED = "REFUNDED",
  VOIDED = "VOIDED",
}

export enum EFulfillmentStatus {
  UNFULFILLED = "UNFULFILLED",
  PARTIAL = "PARTIAL",
  FULFILLED = "FULFILLED",
  RESTOCKED = "RESTOCKED",
}
